// Lógica pura del plano del estacionamiento (CA1, piso 3). Sin React.

export const TIPOS = {
  libre: {
    etiqueta: 'Libre · todo el personal',
    descripcion: 'Cualquier persona de la torre puede estacionarse aquí.',
  },
  privado_sura: {
    etiqueta: 'Privado de Sura',
    descripcion: 'Puesto privado de Sura.',
  },
  gerencia: {
    etiqueta: 'Reservado · gerencia',
    descripcion: 'Reservado para la gerencia de Sura de Venezuela.',
  },
  privado: {
    etiqueta: 'Privado',
    descripcion: 'Puesto privado.',
  },
};

// Plano leido de la lamina original (piso 3). Unidad horizontal: una columna de la fila
// inferior (0 = 125 ... 15 = 110). La fila superior usa columnas fraccionarias porque en la
// lamina esta corrida respecto a la inferior: 126 queda sobre el 110 y 129 sobre el 113.
const SUPERIOR = [
  [135, 2.15], [134, 3.15],
  [133, 6.7], [132, 7.7], [131, 8.7], [130, 9.7],
  [129, 12], [128, 13], [127, 14], [126, 15],
];
const INFERIOR = [125, 124, 123, 122, 121, 120, 119, 118, 117, 116, 115, 114, 113, 112, 111, 110];

export const DISTRIBUCION = [
  ...SUPERIOR.map(([numero, columna]) => ({ numero, fila: 'superior', columna })),
  ...INFERIOR.map((numero, columna) => ({ numero, fila: 'inferior', columna })),
];

// Rampas (calzada de dos carriles): una a la izquierda del 135 y otra entre el 134 y el 133.
export const RAMPAS = [
  { columna: 0.39, fila: 'superior' },
  { columna: 4.68, fila: 'superior' },
];

// Bloque de escaleras: ocupa 1.3 columnas entre el 130 y el 129.
export const ESCALERAS = { columna: 10.7, columnas: 1.3, fila: 'superior' };

// Medidas del plano en px "nativos"; el plano completo se escala para llenar su tarjeta.
const PASO = 70;
const ANCHO = 62;
const ALTO = 104;
const MARGEN_X = 14;
const Y_SUP = 30;
const PASILLO = 84;
const MARGEN_INF = 36;
const ANCHO_RAMPA = 96;
const ALTO_RAMPA = 150;

export const GEOMETRIA = {
  paso: PASO,
  ancho: ANCHO,
  alto: ALTO,
  margenX: MARGEN_X,
  ySup: Y_SUP,
  pasillo: PASILLO,
  yInf: Y_SUP + ALTO + PASILLO,
  anchoRampa: ANCHO_RAMPA,
  altoRampa: ALTO_RAMPA,
  anchoEscalera: ESCALERAS.columnas * PASO - (PASO - ANCHO),
  anchoPlano: MARGEN_X * 2 + 15 * PASO + ANCHO,
  altoPlano: Y_SUP + ALTO + PASILLO + ALTO + MARGEN_INF,
};

// Posicion x (px nativos) del borde izquierdo de una columna; redondeada para evitar
// restos de coma flotante con las columnas fraccionarias.
export function xColumna(columna) {
  return Math.round((GEOMETRIA.margenX + columna * GEOMETRIA.paso) * 100) / 100;
}

export const ESCALA_MIN = 0.72;
export const ESCALA_MAX = 1.2;

// Escala para que el plano ocupe el ancho disponible. Por debajo del minimo el contenedor
// se desplaza en horizontal en vez de encoger mas los puestos. Se redondea hacia abajo para
// que el plano escalado nunca pase del ancho medido (evita una barra de desplazamiento de 1px).
export function escalaPlano(anchoDisponible) {
  if (!(anchoDisponible > 0)) return 1;
  const proporcion = Math.floor((anchoDisponible / GEOMETRIA.anchoPlano) * 1000) / 1000;
  return Math.min(ESCALA_MAX, Math.max(ESCALA_MIN, proporcion));
}

export function puestoUsable(tipo, esGerencia) {
  // Quien entra al portal es personal de Sura: los puestos "Privado de Sura" son suyos.
  if (tipo === 'libre' || tipo === 'privado_sura') return true;
  if (tipo === 'gerencia') return Boolean(esGerencia);
  return false;
}

export function puestosUsables(puestos, esGerencia) {
  return (puestos || [])
    .filter((p) => puestoUsable(p.tipo, esGerencia))
    .map((p) => p.numero)
    .sort((a, b) => a - b);
}
